import { render, staticRenderFns } from "./payment_confirmation.vue?vue&type=template&id=633189d8&"
import script from "./payment_confirmation.vue?vue&type=script&lang=js&"
export * from "./payment_confirmation.vue?vue&type=script&lang=js&"
import style0 from "./payment_confirmation.vue?vue&type=style&index=0&id=633189d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports